export const firebase = window.firebase;



/** WEBPACK FOOTER **
 ** ./src/firebase/index.js
 **/